import React from 'react';
import { FaVideo, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { CCTVCamera } from '../utils/cctvTypes';
import { getRelativeTime } from '../utils/cctvApiService';

interface CCTVCameraCardsProps {
  cameras: CCTVCamera[];
  onCameraClick: (camera: CCTVCamera) => void;
}

const CCTVCameraCards: React.FC<CCTVCameraCardsProps> = ({ cameras, onCameraClick }) => {
  if (cameras.length === 0) {
    return (
      <div className="no-data">
        <div className="no-data-icon"><FaVideo /></div>
        <h3>No cameras found</h3>
        <p>No CCTV cameras available for the selected filters.</p>
      </div>
    );
  }

  return (
    <div className="camera-cards-grid">
      {cameras.map((camera) => (
        <div
          key={camera.id}
          className={`camera-card ${camera.status}`}
          onClick={() => onCameraClick(camera)}
        >
          <div className="card-header">
            <div className="camera-info">
              <FaVideo className="camera-icon" />
              <span className="camera-name">{camera.name}</span>
            </div>
            <span className={`status-indicator ${camera.status}`}>
              {camera.status === 'active' ? 'Working' : 'Non-Working'}
            </span>
          </div>

          <div className="card-body">
            <div className="info-row">
              <FaMapMarkerAlt className="info-icon" />
              <span>{camera.station}</span>
            </div>
            <div className="info-row">
              <FaClock className="info-icon" />
              <span>{getRelativeTime(camera.lastActivity)}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CCTVCameraCards;
